import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlBorderedWrapperComponent } from './control-bordered-wrapper.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ControlBorderedWrapperComponent],
  exports: [ControlBorderedWrapperComponent],
})
export class ControlBorderedWrapperModule {}
